import React from "react";
import { useTranslation } from "react-i18next";

export default function SuperSoundSavePanel({
  user,
  mediaFile,
  isVideo,
  folders,
  selectedFolderId,
  onSelectFolder,
  newFolderName,
  onNewFolderNameChange,
  onCreateFolder,
  onSave,
  saving,
}) {
  const { t } = useTranslation();

  if (!user) {
    return (
      <div className="ss-save-panel">
        <p className="ss-muted">{t("sound_save_sign_in_hint")}</p>
      </div>
    );
  }

  if (isVideo) {
    return (
      <div className="ss-save-panel">
        <p className="ss-muted">{t("sound_save_audio_only")}</p>
      </div>
    );
  }

  if (!mediaFile) {
    return null;
  }

  const selectedFolder = folders.find((f) => f.id === selectedFolderId);

  return (
    <div className="ss-save-panel">
      <p className="ss-save-panel-title">{t("sound_save_panel_title")}</p>
      <ol className="ss-save-steps">
        <li>{t("sound_save_step_folder")}</li>
        <li>{t("sound_save_step_save")}</li>
      </ol>
      <div className="ss-save-row">
        <label className="ss-save-label" htmlFor="ss-folder-select">
          {t("sound_save_destination")}
        </label>
        {folders.length ? (
          <select
            id="ss-folder-select"
            className="ss-folder-select"
            value={selectedFolderId || ""}
            onChange={(e) => onSelectFolder(e.target.value)}
          >
            {folders.map((folder) => (
              <option key={folder.id} value={folder.id}>
                {folder.name}
              </option>
            ))}
          </select>
        ) : (
          <p className="ss-muted">{t("sound_save_no_folders_yet")}</p>
        )}
      </div>
      <div className="ss-folder-create ss-save-create">
        <input
          type="text"
          placeholder={t("sound_new_folder")}
          value={newFolderName}
          onChange={(e) => onNewFolderNameChange(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onCreateFolder()}
        />
        <button type="button" className="ss-btn ss-btn-ghost" onClick={onCreateFolder}>
          {t("sound_create_folder")}
        </button>
      </div>
      <button
        type="button"
        className="ss-btn ss-btn-primary ss-save-cta"
        onClick={onSave}
        disabled={saving || !selectedFolderId}
      >
        {saving ? t("sound_saving") : t("sound_save_to_named", { name: selectedFolder?.name || "…" })}
      </button>
    </div>
  );
}
